import _axios from '@/plugins/axios';

export default {
	async getSchedulesByOwnerId (ownerId) {
		const response = await _axios.get(`schedule/getbyownerId/${ownerId}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new Error(response.data.msg);
	},
	async getSchedulesByLocationId (locationId) {
		const response = await _axios.get(`schedule/getbylocationId/${locationId}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new Error(response.data.msg);
	},
	async createSchedule (body) {
		const res = await _axios.post('schedule', body);
		return res;
	},
	async updateSchedule (body) {
		const res = await _axios.put(`schedule/${body.id}`, body);
		return res;
	},
	async editScheduleTaskDetail (body) {
		const res = await _axios.put(`schedule/editscheduletaskdetail/${body.id}`, body);
		return res;
	},

	async createScheduleTaskDetail (body) {
		const res = await _axios.post('schedule/createscheduletaskdetail', body);
		return res;
	},

	async deleteScheduleById (id) {
		const res = await _axios.delete(`schedule/${id}`);
		return res;
	},

	async deleteScheduleTaskDetail (id) {
		const res = await _axios.delete(`schedule/deletescheduletaskdetail/${id}`);
		return res;
	},

};
